export enum PageBackgroundDesign {
  Standard = 'Standard',
  Solid = 'Solid',
  List = 'List',
  Transparent = 'Transparent'
}
